<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
        <div class="form-wrapper">
          <BaseElDialog
            title="Subir Certificado"
            :visible.sync="showModal"
            @open="handleOpenModalDialog('container-upload-cert-changes')"
            @closed="releaseFocusDialog"
            width="50%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <span :key="t"  v-for="t in processMessage" class="text-center w-full inline-block word-break-n">{{ t }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-upload-cert-changes">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="save" :loading="loading" />
              </div>
            </template>
          </BaseElDialog>
          <BaseElDialog
            title="Comprobación de datos"
            :visible.sync="showModalCheckData"
            @open="handleOpenModalDialog('container-check-data-changes')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <span :key="t"  v-for="t in processMessageCheckData" class=" w-full inline-block word-break-n">{{ t }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-check-data-changes">
                <base-button class="w-full" @click="showModalCheckData = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="subirCertificado" :loading="loading" />
              </div>
            </template>
          </BaseElDialog>
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
            class="flex flex-row w-full"
          >
          <div class="flex-1">

            <div class="lg:mb-2">
              <AccessibleElSelect
                class="w-full"
                v-model="form.type"
                prop="type"
                :options="tiposCertificadoForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="!isCreate"
                @change="onChangeType"
                id-prefix="certificate"
              >
                <template slot="label">{{$t('certificates.type_extend')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <AccessibleElSelect
                  class="w-full"
                  v-model="form.clienteId"
                  prop="clienteId"
                  :options="clientesForAccessibleSelect"
                  :withFormItem="true"
                  :isDisabled="!isCreate"
                  id-prefix="certificate"
                >
                  <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('app.client')}}</template>
                </AccessibleElSelect>
                <base-button v-if="!isCreate" class="ml-4 mb-0.5" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>

            <div v-if="isCreate && form.type === 'pfx'" >
               <div class="lg:mb-2">
                    <span id="cert-password-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('certificates.password')}}</span>
                    <el-form-item prop="password">
                      <el-input
                        ref="passwordInputCert"
                        aria-labelledby="cert-password-label"
                        show-password
                        autocomplete="new-password"
                        v-model="form.password"
                        maxlength='255'
                      >
                        <template v-if="form.password" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de contraseña"
                            @clear="form.password = ''"
                          />
                        </template>
                      </el-input>
                    </el-form-item>
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2  mb-2 lg:mb-0">
                    <base-obligatory-icon v-if="isCreate"/>
                    <el-form-item prop="file" ref="uploadpfxref">
                      <Upload
                        role="button"
                        ref="upload"
                        accept=".pfx,.p12"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900 "
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload']"
                        drag
                        action="#"
                        :show-file-list="false"
                        :multiple="false"
                        :auto-upload=false
                        :on-remove="handleRemove"
                        :on-change="handleChange">
                        <i class="el-icon-upload"></i>
                        <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
                        <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                      </Upload>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2" v-if="form.type === 'srl'">
              <div v-if="isCreate">
                <span id="cert-serial-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('certificates.serial')}}</span>
                <el-form-item prop="HashPFX">
                  <el-input
                    aria-labelledby="cert-serial-label"
                    v-model="form.HashPFX"
                    maxlength='100'
                    >
                    <template v-if="form.HashPFX" slot="suffix">
                      <base-clear-input-button
                        aria-label="Limpiar campo de número de serie"
                        @clear="form.HashPFX = ''"
                      />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <span id="cert-name-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.name')}}</span>
              <el-form-item prop="CommonName">
                <el-input
                  aria-labelledby="cert-name-label"
                  v-model="form.CommonName"
                  maxlength='250'
                  >
                  <template v-if="form.CommonName" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre"
                      @clear="form.CommonName = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div class="mb-2" v-if="isCreate && form.type === 'usr'">
              <span id="cert-user-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('certificates.user')}}</span>
              <el-form-item prop="user">
                <el-input
                  aria-labelledby="cert-user-label"
                  v-model="form.user"
                  maxlength='50'
                  >
                  <template v-if="form.user" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de usuario"
                      @clear="form.user = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
              <span id="cert-pass-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('certificates.pass')}}</span>
              <el-form-item prop="pass">
                <el-input
                  ref="passwordInputCertUser"
                  aria-labelledby="cert-pass-label"
                  show-password
                  v-model="form.pass"
                  maxlength='50'
                  >
                  <template v-if="form.pass" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de contraseña"
                      @clear="form.pass = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div class="mb-2" v-if="isCreate && (form.type === 'srl' || form.type === 'usr')">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('certificates.expires_at')}}
                <el-form-item prop="CertFechaCaducidad">
                  <el-date-picker
                    class="bg-white dark:bg-darkblue-900 "
                    v-model="form.CertFechaCaducidad"
                    type="date"
                    format="dd-MM-yyyy"
                    :picker-options="dateRangeOptions"
                    placeholder="dd-mm-aaaa"
                    ref="datePickerFechaCaducidad"
                    @blur="onBlurDatePickerMixin('.datePickerFechaCaducidad-popover')"
                    @focus="onFocusDatePickerMixin('.datePickerFechaCaducidad-popover')"
                    @keydown.native="captureKeyNotChrome"
                    popper-class="datePickerFechaCaducidad-popover"
                    >
                  </el-date-picker>
                </el-form-item>
              </label>
            </div>

            <div v-if="!isCreate">
              <div v-if="form.type !== 'srl'" class="mb-2">
                <base-ro-input :label="$t('certificates.name')" :data="form.CommonName"/>
              </div>
              <div class="mb-2">
                    <base-ro-input :label="$t('certificates.serial')" :data="form.HashPFX"/>
                  </div>
              <div class="mb-2" v-if="form.type === 'pfx'">
                <div class="mandatory">
                  <base-ro-input :label="$t('certificates.expires_at')" :data="form.CertFechaCaducidad"/>
                </div>
              </div>
              <div class="mb-2" v-else>
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.expires_at')}}
                    <el-form-item prop="CertFechaCaducidad">
                      <el-date-picker
                        class="bg-white dark:bg-darkblue-900 "
                        :disabled="role === 'Usuario' || role === 'UsuarioConsulta'"
                        v-model="form.CertFechaCaducidad"
                        type="date"
                        format="dd-MM-yyyy"
                        :picker-options="dateRangeOptions"
                        placeholder="dd-mm-aaaa"
                        ref="datePickerFechaCaducidad2"
                        @blur="onBlurDatePickerMixin('.datePickerFechaCaducidad2-popover')"
                        @focus="onFocusDatePickerMixin('.datePickerFechaCaducidad2-popover')"
                        @keydown.native="captureKeyNotChrome"
                        popper-class="datePickerFechaCaducidad2-popover"
                        >
                      </el-date-picker>
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>
          </div>
          </el-form>
        </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isCreate ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="showFixCertificate" mode="primary" :text="$t('certificates.fix')" icon="tool" @click="fixCertificate()" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="isCreate || (this.form.type !== 'pfx' && role !== 'Usuario' && role !== 'UsuarioConsulta')" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="!isCreate && !isRoleUserOrConsulta" mode="primary" :text="$t('certificates.replace')" icon="switchhorizontal" @click="replaceCertificate()" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <create-asociate-cif-to-certificate-dialog 
        v-if="isCreate"
        :dialogOpen="dialogOpenCreateAsociate" 
        @toggleDialog="toggleDialogCreateAsociate" 
        @applyDialog="applyCreateAsociate" 
        @cleanAll="cleanAll"
        :isCreated="dialogForm.isCreated"
        :IdCIFEmpresa="dialogForm.IdCIFEmpresa"
        :NombreCert="dialogForm.NombreCert"
        :SerialCert="dialogForm.SerialCert"
        :InitialCIF="dialogForm.InitialCIF"
        :InitialNombreCIF="dialogForm.InitialNombreCIF"
        />
    </template>
  </detail-layout>
</template>

<script>
import { TIPOS_CERT } from '@/config/tipos-cert'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getCertificate } from '@/services/certificates/getCertificate'
import { getPfxData } from '@/services/certificates/getPfxData'

// import { i18n } from '@/i18n'
import { Upload } from 'element-ui'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { uploadPFX } from '@/services/certificates/uploadPFX'
import { uploadSerial } from '@/services/certificates/uploadSerial'
import { uploadUserPass } from '@/services/certificates/uploadUserPass'
// import PfxGrid from '@/components/PfxGrid.vue'
import moment from 'moment'
import { getClients } from '@/services/clients/getClients'
import { i18n } from '@/i18n'

import BaseElDialog from '@/components/base/BaseElDialog.vue'
import CreateAsociateCifToCertificateDialog from '@/components/CreateAsociateCifToCertificateDialog.vue'
import { linkCertificate } from '@/services/certificates/linkCertificate'  
import { repararCertificado } from '@/services/certificates/repararCertificado'  
import { updatecertificadotiposerial } from '@/services/certificates/updatecertificadotiposerial' 
import { createCompanyAutoFill } from '@/services/companies/createCompanyAutoFill'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    Upload,
    BaseElDialog,
    DetailLayout,
    // DetailLayoutFullWidth,
    AccessibleElSelect,
    CreateAsociateCifToCertificateDialog,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      loading: false,
      searchView: false,
      activeName: 'es',
      clientes: [],
      header: {
        title: ' DETALLE DE CERTIFICADO',
        icon: 'certificates',
        breadcrumb: {},
        nav: [],
        url: 'certificates'
      },
      file: {
        name: '',
        b64: ''
      },
      selectedCifs: [],
      cifHasCertif: false, // flag para indicar que se va a vincular un certificado a un cif que ya tiene otro certificado
      showModal: false,
      showModalCheckData: false,
      // Comprobación cert
      checkDataSerialNumber: '',
      checkDataCommonName: '',
      checkDataExpirationDate: '',
      tiposCertificado: TIPOS_CERT,
      dialogOpenCreateAsociate: false,
      form: {
        type: 'pfx',
        CommonName: '',
        HashPFX: '',
        CertFechaCaducidad: '',
        file: '',
        password: '',
        clienteId: null,
        user: '',
        pass: '',
        id: 0
      },
      dialogForm: {
        isCreated: true,
        IdCIFEmpresa: -1,
        NombreCert: null,
        SerialCert: null,
        TipoCertificado: '',
        InitialCIF: null,
        InitialNombreCIF: null,
      },
      rules: {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        password: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        HashPFX: [
          { validator: this.isSerialNumberValid, trigger: 'blur' }
        ],
        CommonName: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        user: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        pass: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        type: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        CertFechaCaducidad: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        file: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.not_pfx'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              console.log(this.file.name.substr(this.file.name.length - 4).toUpperCase())
            
              if (!this.file.name || 
                this.file.name.length < 5 || 
                !['.PFX', '.P12'].includes(this.file.name.substr(this.file.name.length - 4).toUpperCase())
                // this.file.name.substr(this.file.name.length - 4).toUpperCase() !== '.PFX' ||
                // this.file.name.substr(this.file.name.length - 4).toUpperCase() !== '.P12'
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    empresaFilter () {
      return this.isCreate ? this.$store.getters['certificates/getMasterFilters']?.empresa?.value || null : null
    },
    showFixCertificate () {
      return !this.isCreate && this.role === 'SuperAdministrador' && this.tipoCertificado === 'pfx'
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    idEmpresa: function () {
      return parseInt(this.$route.params.idEmpresa)
    },
    serial: function () {
      return this.$route.params.serial
    },
    tipoCertificado: function () {
      return this.$route.params.tipo
    },
    isCreate: function () {
      return this.idEmpresa === -1 || this.idEmpresa === '-1' || this.serial === -1 || this.serial === '-1' || this.tipo === -1 || this.tipo === '-1'
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    processMessage: function () {
      const message = []
      if (this.cifHasCertif) {
        message.push('Vas a sobrescribir NIFs ya vinculados.')
      }
      let nombreCert = ''
      if (this.form.type === 'pfx') nombreCert = this.file.name
      else if (this.form.type === 'srl') nombreCert = 'con serial "' + this.form.HashPFX + '"'
      else if (this.form.type === 'usr') nombreCert = 'con usuario "' + this.form.user + '"'
      message.push('¿Quieres subir el certificado ' + nombreCert + '?')

      return message
    },
    processMessageCheckData: function () {
      const message = []
      message.push('¿Quieres subir el certificado seleccionado que contiene los siguientes datos?')
      message.push('')
      message.push('Número de serie: ' + this.checkDataSerialNumber)
      message.push('Nombre: ' + this.checkDataCommonName)
      message.push('Fecha de caducidad: ' + moment(this.checkDataExpirationDate).format('DD-MM-yyyy HH:mm'))

      return message
    },
    isAdmin: function () {
      return this.$store.getters['app/isAdmin']
    },
    allCifs: function () {
      return this.$store.getters['app/allCifs']
    },
    links: function () {
      const links = []
      this.allCifs.forEach(row => {
        links.push({ id: row.IdCIFEmpresa, value: row.CIF })
      })

      return links
    },
    empresas: function () {
      return this.$store.getters['app/empresas']
    },
    gettingCifs: function () {
      return this.$store.getters['app/gettingCifs']
    },
    tiposCertificadoForAccessibleSelect () {
      return this.tiposCertificado.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled === true
      }))
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        name: cliente.Nombre,
        value: cliente.IdEmpresa
      }))
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.type': function (value, oldValue) {
      if (this.isCreate) {
        this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
      }
      if (this.form.type === 'pfx') this.fixAccesibilityElPassword()
      if (this.form.type === 'usr') this.fixAccesibilityElPasswordUser()
    },
  },
  created: async function () {
    const idEmpresa = this.idEmpresa
    const serial = this.serial
    const tipoCert = this.tipoCertificado
    const breadcrumbs = []
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      if (this.isCreate) this.preSelectClient(this.form, 'clienteId')
    }

    if (!this.isCreate) {
      await this.downloadData(idEmpresa, serial, tipoCert)
      if (this.$route.params.noticeType !== undefined && this.$route.params.noticeType !== null && this.$route.params.noticeType !== '') {
        if (this.$route.params.noticeType === 'certificadoscaducar') {
          this.header.url = 'notices/certificadoscaducar'
          breadcrumbs.push({ path: 'notices/certificadoscaducar', name: this.$i18n.t('app.noticesCertsCaduc') })
        } else {
          this.header.url = 'notices/certificadoscaducados'
          breadcrumbs.push({ path: 'notices/certificadoscaducados', name: this.$i18n.t('app.noticesCertsCaducados') })
        }
      } else {
        breadcrumbs.push({ path: 'certificates', name: this.$i18n.t('app.certificates') })
      }
      this.form.name = serial
      breadcrumbs.push({ path: '', name: this.form.CommonName })
      this.$store.commit('app/setheaderBreadCrumb', this.form.CommonName)
    } else {
      breadcrumbs.push({ path: '', name: this.$i18n.t('certificates.new_certificate') })
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.resetControlFormChanges()
    if (this.isCreate) {
      this.fixAccesibilityElPassword()
      this.fixAccesibilityElPasswordUser()
    } 
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    fixAccesibilityElPassword () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputCert, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    fixAccesibilityElPasswordUser () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputCertUser, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    toggleDialogCreateAsociate () {
      this.dialogOpenCreateAsociate = !this.dialogOpenCreateAsociate
    },
    applyCreateAsociate: async function (data) {
      this.toggleDialogCreateAsociate()
      let idEmpresa
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        idEmpresa = this.form.clienteId
      } else {
        idEmpresa = this.$route.params.idEmpresa
      }
      if (data.isCreated) {
        const payload = {
          idCIFS: [data.IdCIFEmpresa],
          serialCert: this.checkDataSerialNumber,
          tipoCertificado: 'pfx',
          idEmpresa: idEmpresa
        }
        // Vincular
        this.linkCertificate(payload)
      } else {
        // Crear y vincular
        const payloadCreate = {
          CIF: data.CIF,
          RazonSocial: data.NombreCIF,
          idCliente: idEmpresa
        }
        const responseCreate = await createCompanyAutoFill(payloadCreate)
        if (responseCreate.blnError === true) {
          this.doFeedback(responseCreate.msgError + ' [Código de error: ' + responseCreate.codError + ']')
        } else {
          const payloadLink = {
            idCIFS: [responseCreate.IdCIFEmpresa],
            serialCert: this.checkDataSerialNumber,
            tipoCertificado: 'pfx',
            idEmpresa: idEmpresa
          }
          this.linkCertificate(payloadLink)
        }
      }
      this.cleanAll()
    },
    linkCertificate: async function (data) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await linkCertificate(data)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Certificado vinculado con éxito', 'success')
          this.resetControlFormChanges()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    createCompanyAutoFill: async function (data) {
      let response = {
        blnError: true,
      }
      try {
        this.$store.commit('setIsLoading', true)
        response = await createCompanyAutoFill(data)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.resetControlFormChanges()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return response
    },
    isSerialNumberValid: function (rule, value, callback) {
      const re = /["<>|:*?\\/]/
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      } else if (re.test(value)) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.codigo_ext.chars'), callback)
      } else if (value.length < 5) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.length_min') + '5 caracteres', callback)
      } else {
        callback()
      }
    },
    replaceCertificate () {
      this.$router.push({ 
        name: 'certificates/replace',
        params: { 
          idEmpresa: this.idEmpresa, 
          serial: this.serial,
          tipo: this.tipoCertificado,
          name: this.form.CommonName, 
          noticeType: this.$route.params.noticeType
        } 
      })
    },
    fixCertificate: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          SerialNumber: this.serial,
          idCliente: this.idEmpresa
        }
        const response = await repararCertificado(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onChangeType: function (value) {
      // console.log('onChangeType', value)
    },
    watchFormHandler: function ({ CertFechaCaducidad }) {
      if (this.isCreate) {
        if (CertFechaCaducidad !== undefined && moment(CertFechaCaducidad).isValid()) {
          this.form.CertFechaCaducidad = moment(CertFechaCaducidad).format('YYYY-MM-DD')
        } else {
          this.form.CertFechaCaducidad = ''
        }
      }
      this.$store.commit('app/setFormChanges', true)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isCreate) {
            this.cifHasCertif = false
            if (this.form.type === 'pfx') this.uploadPFX()
            else this.showModal = true
          } else {
            this.handleUpdateSerial(formName) 
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
          return false
        }
      })
    },
    handleUpdateSerial (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let idEmpresa
          if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
            idEmpresa = this.form.clienteId
          } else {
            idEmpresa = this.$route.params.idEmpresa
          }
          const payload = {
            SerialNumber: this.form.HashPFX,
            CommonName: this.form.CommonName,
            FechaExpiracion: moment(this.form.CertFechaCaducidad).format('YYYY-MM-DD[T00:00:00]'),
            idEmpresa
          }
          const response = await updatecertificadotiposerial(payload)
          if (response.blnError === false) {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetControlFormChanges()
          } else {
            this.doFeedback(response.msgError)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'certificates' })
    },
    goDetailClient () {
      const id = this.idEmpresa
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    downloadData: async function (idEmpresa, serial, tipoCertificado) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa,
          serial,
          tipoCertificado
        }
        const data = await getCertificate(params)
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          this.setCertificate(data.Certificado)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCertificate: function (certificate) {
      this.form.HashPFX = certificate.HashPFX
      this.form.type = certificate.TipoCertificado
      this.form.CommonName = certificate.CommonName
      this.form.CertFechaCaducidad = (!this.isCreate && (this.form.type === 'srl' || this.form.type === 'usr')) 
        ? certificate.CertFechaCaducidad
        : moment(certificate.CertFechaCaducidad).format('DD-MM-yyyy HH:mm')
      this.form.clienteId = certificate.idEmpresa
      this.resetControlFormChanges()
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    getEmpresas: function () {
      this.$store.dispatch('app/getEmpresas')
    },
    save: async function () {
      try {
        this.loading = true
        await this.uploadPFX()
        this.showModal = false
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loading = false
      }
    },
    uploadPFX: async function () {
      let idEmpresa
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        idEmpresa = this.form.clienteId
      } else {
        idEmpresa = this.$route.params.idEmpresa
      }

      if (this.form.type === 'pfx') {
        const payload = {
          base64: this.file.b64,
          pwd: this.form.password,
          idEmpresa: idEmpresa,
        }
        const responseGetData = await getPfxData(payload)
        if (responseGetData.blnError === false) {
          this.checkDataSerialNumber = responseGetData.datosCertificado.SerialNumber
          this.checkDataCommonName = responseGetData.datosCertificado.CommonName 
          this.checkDataExpirationDate = responseGetData.datosCertificado.ExpirationDate
          this.showModalCheckData = true
        } else {
          this.doFeedback(responseGetData.msgError + ' [Código de error: ' + responseGetData.codError + ']')
        }
      } else {
        this.subirCertificado()
      }
    },
    subirCertificado: async function () {
      this.showModalCheckData = false
      this.$store.commit('app/setLoading', true)
      let idEmpresa
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        idEmpresa = this.form.clienteId
      } else {
        idEmpresa = this.$route.params.idEmpresa
      }

      let response = null
      if (this.form.type === 'pfx') {
        response = await uploadPFX(this.file.b64, this.form.password, idEmpresa, this.file.name)
      } else if (this.form.type === 'srl') {
        response = await uploadSerial({
          SerialNumber: this.form.HashPFX,
          CommonName: this.form.CommonName,
          FechaExpiracion: this.form.CertFechaCaducidad,
          idEmpresa
        })
      } else if (this.form.type === 'usr') {
        response = await uploadUserPass({
          Usuario: this.form.user,
          Password: this.form.pass,
          FechaExpiracion: this.form.CertFechaCaducidad,
          idEmpresa
        })
      }

      if (response.blnError === false) {
        this.doFeedback('Certificado subido con éxito', 'success')
        this.resetControlFormChanges()
        if (this.form.type === 'pfx' && !this.isRoleUserOrConsulta) {
          // Setear y abrir dialogo
          this.dialogForm.isCreated = response.existeCIF
          this.dialogForm.IdCIFEmpresa = response.datosCertificadoCIF.idCIFEmpresa
          this.dialogForm.InitialCIF = response.datosCertificadoCIF.CIF
          this.dialogForm.InitialNombreCIF = response.datosCertificadoCIF.RazonSocial
          if (response.datosCertificadoCIF.datosCertificadoVinculado) {
            this.dialogForm.NombreCert = response.datosCertificadoCIF.datosCertificadoVinculado.CommonName
            this.dialogForm.SerialCert = response.datosCertificadoCIF.datosCertificadoVinculado.SerialNumber
          }
          this.toggleDialogCreateAsociate()
        } else {
          this.cleanAll()
        }
      } else {
        this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
      }
      
      this.$store.commit('app/setLoading', false)
    },
    cleanAll () {
      if (this.form.type === 'pfx') this.$refs.upload.clearFiles()
      this.file = {
        name: null,
        b64: null
      }
      this.resetForm()
      const tmpType = this.form.type
      this.form = {
        type: tmpType,
        CommonName: '',
        HashPFX: '',
        CertFechaCaducidad: '',
        file: '',
        password: '',
        clienteId: null,
        user: '',
        pass: '',
        id: 0
      }
      this.checkDataSerialNumber = ''
      this.checkDataCommonName = ''
      this.checkDataExpirationDate = ''
      this.resetControlFormChanges()
      if (this.isCreate && (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')) {
        this.preSelectClient(this.form, 'clienteId')
      }
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    selectionChange: function (selectedData) {
      this.selectedCifs = selectedData
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      this.selectedCifs = []
      this.selectedCifs.push(item)
    }
  }

}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

 .el-loading-parent--relative {
    position: relative !important; }

  .el-loading-parent--hidden {
    overflow: hidden !important; }

    div.el-loading-mask {
        background-color: rgba(6,13,46,.8);
    }

  .el-loading-mask {
    position: absolute;
    z-index: 2000;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s; }
    .el-loading-mask.is-fullscreen {
      position: fixed; }
      .el-loading-mask.is-fullscreen .el-loading-spinner {
        margin-top: -25px; }
        .el-loading-mask.is-fullscreen .el-loading-spinner .circular {
          height: 50px;
          width: 50px; }
    div.el-loading-mask .el-loading-spinner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
body.el-loading-parent--relative {
    position: inherit !important;
}
  .el-loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute; }
    .el-loading-spinner .el-loading-text {
      color: #00BBFF;
      margin: 3px 0;
      font-size: 14px; }
    .el-loading-spinner .circular {
      height: 42px;
      width: 42px;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite; }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #00BBFF;
      stroke-linecap: round; }
    .el-loading-spinner i {
      color: #00BBFF; }

  .el-loading-fade-enter,
  .el-loading-fade-leave-active {
    opacity: 0; }
</style>

<style lang="sass" scoped>
</style>
